<script setup>
import { RBN_IMAGE_UPLOAD } from '@/utils/constants';

definePageMeta({
  middleware: (to) => {
    const localePath = useLocalePath();
    return navigateTo(localePath({ name: RBN_IMAGE_UPLOAD, params: to.params, query: to.query }));
  },
});
</script>
